import React, {useRef, useEffect, useState} from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import notification from "../../../assets/images/icons/header/notification.svg"
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../../../context/notifications';

const Notification = ({
    isNotificationOpen = false,
    onToggle,
}) => {
    const notificationRef = useRef(null);
    const navigate = useNavigate();
    const { notifications, unreadNotifications, unreadCount, markAsRead } = useNotifications();
    const [markTimer, setMarkTimer] = useState(null);

    useEffect(() => {
        if (markTimer) {
            clearTimeout(markTimer);
            setMarkTimer(null);
        }

        if (isNotificationOpen && unreadNotifications.length > 0) {
            const timer = setTimeout(() => {
                const unreadIds = unreadNotifications.map(n => n.id);
                markAsRead(unreadIds);
            }, 2000); 
            
            setMarkTimer(timer);
        }

        return () => {
            if (markTimer) {
                clearTimeout(markTimer);
            }
        };
    }, [isNotificationOpen, unreadNotifications]); 
    
    const handleButtonClick = (e) => {
        e.stopPropagation(); 
        if (onToggle) {
            onToggle();
        }
    };

    const handleViewMoreClick = () => {
        navigate('/historico-de-notificaciones');
        if (onToggle) {
            onToggle(); 
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (notificationRef.current && 
                !notificationRef.current.contains(event.target) &&
                isNotificationOpen &&
                onToggle) {
                onToggle();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isNotificationOpen, onToggle]);

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const notificationDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    
    const diffTime = today.getTime() - notificationDate.getTime();
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    
    if (diffDays === 0) return 'Hoy';
    if (diffDays === 1) return 'Ayer';
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${day}/${month}`;
};

    
  return (
    <div className='relative notification-container' ref={notificationRef}>
        <button
            onClick={handleButtonClick}
            className='relative inline-block p-2 notification-button'>
            <img src={notification} alt="Notification-icon" className='w-full' />
            {unreadCount > 0 && (
                <span className='absolute flex items-center justify-center w-4 h-4 text-[8px] text-white rounded-full top-0 right-0 bg-[#BD002A] font-rubiklight'>
                {unreadCount}
                </span>
            )}
        </button>
        {isNotificationOpen && (
        <div className="absolute bottom-0 z-20 bg-white -right-5 top-[51px] ">
            <div className="w-[262px] max-h-[461px] drop-shadow-notification bg-white rounded-tl-[4px] ">
                <div className='flex items-center  h-[29px] rounded-tl-[4px] px-4 bg-blue'>
                    <p className='text-xs text-white font-itcbook'>Notificaciones</p>
                </div>
                <style>
                    {`
                    .notification-simplebar .simplebar-scrollbar:before {
                    background: #007696 !important;
                    }

                    .notification-simplebar .simplebar-scrollbar {
                    background: #00759657 !important; 
                    border-radius: 4px ;
                    width: 4px;
                    }

                    .notification-simplebar .simplebar-scrollbar {
                    background: #007696 !important; 
                    border-radius: 4px !important;
                    width: 4px !important;
                    }
                    `}
                </style>
                <SimpleBar className=' notification-simplebar' style={{ maxHeight: '432px' }} >

                            {notifications.length === 0 ? (
                                <div className='h-[72px] px-4 py-2 flex items-center justify-center border border-[#D9D9D9]'>
                                    <p className='text-[10px] text-[#3F3F3F] font-itcbook'>Aún no tiene ninguna notificación pendiente.</p>
                                </div>
                            ) : (
                                notifications.map(notification => (
                                <div key={notification.id} className={`h-auto gap-1 text-[10px] px-4 py-2 flex  justify-between border border-[#D9D9D9]
                                ${!notification.visible ? 'bg-blue/[0.1]' : ''}`}>
                                    <div className='flex flex-col'>
                                        <p className='text-blue font-itcmedium '>{notification.title}</p>
                                        <p className='font-itcbook  text-[#3F3F3F]'>{notification.description}</p>
                                    </div>
                                    <div className='flex items-end'>
                                        <p className='text-[#999999] font-itcbook'>{formatDate(notification.created_At)}</p>
                                    </div>
                                </div>
                                ))
                            )}

                            <div className="h-[36px] flex-items-center justify-center text-[10px] px-4 py-2 flex border border-[#D9D9D9] ">
                            <button
                                onClick={handleViewMoreClick}
                                className='text-black hover:text-blue font-itcmedium'>Ver más notificaciones...</button>
                            </div>
                </SimpleBar>
            </div>
        </div>
        )}
    </div>
  );
};
export default Notification;